import { TransportTypeEnum } from '../../enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../enums/trip-bookings/trip-step-type.enum'
import { TripFolderTypeEnum } from '../../enums/trip-folder/trip-folder-type.enum'
import { Time } from '../../utils'
import { CenterBasic } from '../center/center'
import { MissionToExternalStaff } from '../mission-to-external-staff/mission-to-external-staff'
import { MissionToStaff } from '../mission-to-staff/mission-to-staff'
import { CoachCompanyLight } from '../ol/coach-company/coach-company'
import { TransferPlace } from '../transfer/transfer-place'
import { Trip } from '../trip/trip'
import { TripAddress, TripAddressBasic } from '../trip-address/trip-address'
import { TripBookingTypes } from '../trip-booking/trip-booking'
import { TripBookingDispatchPlace } from '../trip-booking-dispatch-places/trip-booking-dispatch-place'

export enum TripFolderPdfSectionsEnum {
  CASES = 'CASES',
  TICKETS = 'TICKETS',
  RESERVATIONS = 'RESERVATIONS',
  CENTERS = 'CENTERS'
}

export type TripFolder = {
  id: number
  createdAt: Date
  updatedAt: Date

  type: TripFolderTypeEnum
  date: Date
  directionality: TripStepTypeEnum
  locked: boolean

  departurePlace: TripAddress
  departureTime: Time
  departureDate: string

  arrivalPlace: TripAddress
  arrivalTime: Time
  arrivalDate: string

  trips: Trip[]
  tripBookings: TripBookingTypes.Light[]

  instruction?: string
}

export type TripFolderStats = {
  numberOfEnrollments: number
  numberOfStaffs: number
  numberOfLecStaffs: number
  numberOfExternalStaffs: number
}

export type TripBookingsIndividualsData = { departurePlace: TripAddress; count: number }

export type TripFolderSecondaryTripBooking = {
  id: number
  createdAt: Date
  updatedAt: Date

  numberOfStudentsPlaced?: number
  directionality: TransportTypeEnum
  arrivalPlace: TripAddress
  arrivalTime: Time
  transferPlaces: TransferPlace[]
  tripBooking: TripBookingTypes.Light
  dispatchPlaces: TripBookingDispatchPlace[]
}

export type TripFolderMissionStaffs = {
  missionToStaffs: MissionToStaff[]
  missionToExternalStaffs: MissionToExternalStaff[]
}

export type TripFolderBooking = TripBookingTypes.Light & {
  enrollments: TripBookingsIndividualsData[]
  staffs: TripBookingsIndividualsData[]
  enrollmentsTotalCount: number
  staffsTotalCount: number
  reservationLabel: string
  secondaryReservation?: TripFolderBooking
}

export type TripFolderPdfInput = {
  printDate?: string
  sections?: TripFolderPdfSectionsEnum[]
  documentIds?: number[]
}

export type TripFolderPdfFormPaxList = {
  reservations?: boolean
  centers?: boolean
}

export type TripFolderPdfFormInput = {
  printDate?: string

  cases?: boolean
  tickets?: boolean

  listOfPax?: TripFolderPdfFormPaxList
  documentIds?: number[]
}

export type TripFolderOlArrival = {
  center: CenterBasic
  appointmentPlace: TripAddressBasic
  appointmentTime: Time
  appointmentTimeZone: string
  appointmentDate: string
  coachCompany: CoachCompanyLight
  guidelineContent: string
}

export type TripFolderBasic = Pick<TripFolder, 'id' | 'directionality'>
